export const hasSeenOnboarding = propertyKey => async (_, {
  api
}) => api.hasSeenOnboarding(propertyKey);